export default __webpack_public_path__ + "static/media/filter_analyst_light.a14008ff.svg";